export default __webpack_public_path__ + "static/media/TVSsportFamilia.24e23a65.webp";